import React, { useEffect, useRef } from 'react';
import { BrowserMultiFormatReader } from '@zxing/browser';
import { BarcodeFormat, DecodeHintType } from '@zxing/library';

const hints = new Map();
hints.set(DecodeHintType.POSSIBLE_FORMATS, [
  BarcodeFormat.QR_CODE, // NFC-e
  BarcodeFormat.CODE_128, // DANFE
]);

/**
 * Lê QR Code (NFC-e) ou Code 128 (DANFE) pela câmera e entrega o texto
 * decodificado em onDetected. Libera a câmera ao desmontar.
 */
export default function InvoiceKeyScanner({ onDetected, onError }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const reader = new BrowserMultiFormatReader(hints, {
      delayBetweenScanAttempts: 300,
    });
    let controls = null;
    let active = true;

    reader
      .decodeFromConstraints(
        { video: { facingMode: 'environment' } },
        videoRef.current,
        result => {
          if (result && active) onDetected(result.getText());
        }
      )
      .then(c => {
        if (active) controls = c;
        else c.stop();
      })
      .catch(err => {
        if (active && onError) onError(err);
      });

    return () => {
      active = false;
      if (controls) controls.stop();
    };
  }, [onDetected, onError]);

  return (
    <video
      ref={videoRef}
      style={{ width: '100%', maxHeight: 360, borderRadius: 8 }}
      muted
      playsInline
    />
  );
}
